// TrailerBlocker.jsx
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import trackMixpanel, {
  EventTypes,
  getViewId,
  ButtonId,
} from '../resource/mixpanel.js';

import ResetButtonStyle from '../style/ResetButtonStyle.js';

export class TrailerBlocker extends React.PureComponent {
  nextTick = undefined;
  state = { isClient: false };

  handleOnClick = () => {
    const { isAuthed, login, openVerifyFreeUserModal } = this.props;
    trackMixpanel({
      type: EventTypes.USER_CLICKED,
      payload: {
        viewId: getViewId({
          pathname: window.location.pathname,
        }),
        buttonId: ButtonId.All.ButtonKycSticker,
      },
    });

    if (isAuthed) return openVerifyFreeUserModal();
    else return login();
  };

  componentDidMount() {
    this.nextTick = setTimeout(() => {
      this.setState({
        isClient: true,
      });
    });
  }

  componentWillUnmount() {
    clearTimeout(this.nextTick);
  }

  render() {
    const {
      blockerUrl,
      enlarge,
      zIndex,
      shouldBlock,
      isRemoteConfigMerged,
      canBeClick,
    } = this.props;
    const { isClient } = this.state;
    if (!blockerUrl || !shouldBlock || !isClient || !isRemoteConfigMerged) {
      return null;
    }
    return (
      <StyledTrailerBlocker
        zIndex={zIndex}
        enlarge={enlarge}
        canBeClick={canBeClick}
        onClick={canBeClick ? this.handleOnClick : null}
      >
        <Image src={blockerUrl} alt="under age blocker" />
      </StyledTrailerBlocker>
    );
  }
}

TrailerBlocker.propTypes = {
  blockerUrl: PropTypes.string,
  zIndex: PropTypes.string,
  isAuthed: PropTypes.bool,
  shouldBlock: PropTypes.bool,
  isRemoteConfigMerged: PropTypes.bool,
  canBeClick: PropTypes.bool,
  enlarge: PropTypes.number,
  openVerifyFreeUserModal: PropTypes.func,
  login: PropTypes.func,
};

TrailerBlocker.defaultProps = {
  blockerUrl: '',
  zIndex: '0',
  isAuthed: false,
  shouldBlock: true,
  isRemoteConfigMerged: false,
  canBeClick: false,
  enlarge: 0,
  openVerifyFreeUserModal: () => null,
  login: () => null,
};

const StyledTrailerBlocker = styled.button`
  ${ResetButtonStyle}
  position: absolute;
  top: -${({ enlarge }) => 0.5 * enlarge}%;
  left: -${({ enlarge }) => 0.5 * enlarge}%;
  width: ${({ enlarge }) => 100 + enlarge}%;
  height: ${({ enlarge }) => 100 + enlarge}%;
  background-color: #000a;
  z-index: ${({ zIndex }) => zIndex};
  cursor: ${({ canBeClick }) => (canBeClick ? 'pointer' : 'default')};
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export default TrailerBlocker;
